module.exports = __webpack_public_path__ + "static/media/bprotocol.66df1df8.svg";